<template>
  <div class="navbar navbar-expand-md navbar-dark fixed-top">
    <div class="navbar-brand">
      <router-link to="/" class="d-inline-block">
        <img src="../../assets/light-logo.webp" alt="" />
        <span>Data Tagging Tool</span>
      </router-link>
    </div>

    <div class="d-md-none">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar-mobile"
      >
        <i class="icon-tree5"></i>
      </button>
    </div>

    <div class="collapse navbar-collapse" id="navbar-mobile">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            href="#"
            class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
          >
          </a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link
            to="/login"
            href="#"
            class="navbar-nav-link d-flex align-items-center"

          >
            <span>Login</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'navbarFrontend'
}
</script>
